var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './Input.module.scss';
import { Eye, EyeOff } from '../../assets/icons';
import { ANIMATE_HEIGHT } from '../../constants';
var Input = function (_a) {
    var name = _a.name, type = _a.type, value = _a.value, label = _a.label, placeholder = _a.placeholder, disabled = _a.disabled, required = _a.required, small = _a.small, icon = _a.icon, noMargin = _a.noMargin, error = _a.error, errorMessage = _a.errorMessage, className = _a.className, inputClassName = _a.inputClassName, autoFocus = _a.autoFocus, id = _a.id, dataId = _a.dataId, onEnter = _a.onEnter, onChange = _a.onChange, shouldReset = _a.shouldReset, setShouldReset = _a.setShouldReset;
    var _b = useState(false), passVisible = _b[0], setPassVisible = _b[1];
    var inputRef = useRef(null);
    var isPassword = type === 'password';
    var classes = "".concat(icon ? styles.WithCustomIcon : '', " ").concat(isPassword ? styles.WithPassIcon : '', " ").concat(error ? styles.Error : '');
    var onInputChange = function (e) {
        onChange && onChange(e.target.value);
        setShouldReset && setShouldReset(false);
    };
    var onInputKeyUp = function (e) {
        if (e.key === 'Enter')
            onEnter === null || onEnter === void 0 ? void 0 : onEnter();
    };
    var renderPassIcon = function () {
        return passVisible ? _jsx(EyeOff, {}) : _jsx(Eye, {});
    };
    useEffect(function () {
        if (shouldReset && inputRef.current && onChange && value && setShouldReset) {
            onChange('');
            inputRef.current.focus();
            setShouldReset(false);
        }
    }, [shouldReset]);
    return (_jsxs("div", __assign({ id: id, className: "".concat(styles.InputContainer, " ").concat(small ? styles.Small : '', " ").concat(className ? className : '') }, { children: [label && (_jsxs("label", __assign({ className: styles.Label }, { children: [label, required && _jsx("span", __assign({ className: styles.Required }, { children: "*" }))] }))), _jsxs("div", __assign({ className: "".concat(styles.InputWrapper, " ").concat(noMargin ? styles.NoMargin : '') }, { children: [icon && _jsx("span", __assign({ className: styles.CustomIcon }, { children: icon })), _jsx("input", { ref: inputRef, className: "".concat(styles.Input, " ").concat(inputClassName ? inputClassName : '', " ").concat(classes), name: name, type: passVisible ? 'text' : type, value: value, placeholder: placeholder, disabled: disabled, autoFocus: autoFocus, onChange: onInputChange, onKeyUp: onInputKeyUp, "data-testid": dataId }), isPassword && (_jsx("i", __assign({ className: styles.PassIcon, onClick: function () { return setPassVisible(!passVisible); }, "data-testid": 'pass-icon' }, { children: renderPassIcon() }))), error && errorMessage && _jsx("span", __assign({ className: "".concat(styles.ErrorMessage, " ").concat(ANIMATE_HEIGHT) }, { children: errorMessage }))] }))] })));
};
Input.propTypes = {
    name: PropTypes.string,
    type: PropTypes.oneOf(['text', 'password', 'number']),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    small: PropTypes.bool,
    noMargin: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onEnter: PropTypes.func,
    onChange: PropTypes.func,
    autoFocus: PropTypes.bool,
    shouldReset: PropTypes.bool,
    setShouldReset: PropTypes.func,
};
Input.defaultProps = {
    type: 'text',
    className: '',
    autoFocus: false,
};
export { Input };
//# sourceMappingURL=Input.js.map